import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id });
        await refresh();
        toast.success("Signed in with Google!");
        nav("/", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="flex items-center gap-3 text-[#857163]">
        <div className="cp-cakepop-loader" /> Signing you in with Google…
      </div>
    </div>
  );
}
